import { Search } from 'lucide-react';

interface ScootSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export default function ScootSearchBar({ value, onChange }: ScootSearchBarProps) {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <Search className="h-5 w-5 text-white/30" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Rechercher un créateur par nom, bio, mots-clés..."
        className="w-full pl-12 pr-4 py-4 bg-white/[0.06] border border-white/[0.08] rounded-xl text-white placeholder-white/30 focus:outline-none focus:ring-1 focus:ring-white/20"
      />
    </div>
  );
}
